module.exports = __webpack_public_path__ + "img/chevron-top.ac3b7667.svg";